import { homeContent } from './homeContent';

type HeroContent = (typeof homeContent)['hero']['en'];

const heroPatch: Record<string, HeroContent> = {
  hi: {
    badge: 'एंटरप्राइज-ग्रेड BPO और डिजिटल फैक्ट्री',
    h1: 'दुनिया की अग्रणी BPO और डिजिटल फैक्ट्री — मोरक्को, स्पेन और दुबई से वैश्विक व्यवसायों को शक्ति',
    sub: '500+ एजेंट, 12+ भाषाएँ, 200+ एंटरप्राइज क्लाइंट। 7 दिनों में डिप्लॉयमेंट। 50-70% लागत बचत।',
    ctaPrimary: 'मुफ़्त सप्ताह शुरू करें',
    ctaSecondary: 'BPO सेवाएँ ऑर्डर करें',
    trustBadge: 'पहला सप्ताह मुफ़्त • क्रेडिट कार्ड नहीं • कभी भी रद्द करें',
    microProof: [
      '24/7/365 कवरेज',
      'बहुभाषी टीमें (EN/FR/ES/AR + 8 और)',
      'पश्चिमी यूरोप/USA की तुलना में 50-70% बचत',
      '7 दिनों में गो-लाइव',
      'ISO 27001 • GDPR • PCI-DSS अनुकूल',
    ],
    proofMetrics: [
      { value: '200+', label: 'क्लाइंट्स' },
      { value: '500+', label: 'एजेंट्स' },
      { value: '12+', label: 'भाषाएँ' },
      { value: '95%+', label: 'CSAT' },
      { value: '99.9%', label: 'SLA अपटाइम' },
      { value: '50-70%', label: 'लागत बचत' },
      { value: '7 दिन', label: 'डिप्लॉयमेंट' },
    ],
    trustedBy: 'दुनिया भर की 200+ कंपनियों का भरोसा',
    dialogTitle: 'डिस्कवरी कॉल शेड्यूल करें',
  },
  ro: {
    badge: 'BPO & Fabrică Digitală de nivel enterprise',
    h1: 'Lider global în BPO & Fabrică Digitală — impulsionăm afaceri din Maroc, Spania și Dubai',
    sub: '500+ agenți, 12+ limbi, 200+ clienți enterprise. Lansare în 7 zile. Economii de 50-70%.',
    ctaPrimary: 'Începe Săptămâna Gratuită',
    ctaSecondary: 'Comandă Servicii BPO',
    trustBadge: 'Prima săptămână gratuită • Fără card • Anulezi oricând',
    microProof: [
      'Acoperire 24/7/365',
      'Echipe multilingve (EN/FR/ES/AR + încă 8)',
      'Economii 50-70% vs Europa de Vest/SUA',
      'Go-live în 7 zile',
      'Aliniat ISO 27001 • GDPR • PCI-DSS',
    ],
    proofMetrics: [
      { value: '200+', label: 'Clienți' },
      { value: '500+', label: 'Agenți' },
      { value: '12+', label: 'Limbi' },
      { value: '95%+', label: 'CSAT' },
      { value: '99.9%', label: 'SLA Uptime' },
      { value: '50-70%', label: 'Economii' },
      { value: '7 Zile', label: 'Implementare' },
    ],
    trustedBy: 'Peste 200 de companii ne acordă încredere',
    dialogTitle: 'Programează un Discovery Call',
  },
  cs: {
    badge: 'Enterprise BPO & Digitální Studio',
    h1: 'Světový lídr v BPO a digitální továrně — růst globálních firem z Maroka, Španělska a Dubaje',
    sub: '500+ agentů, 12+ jazyků, 200+ enterprise klientů. Nasazení do 7 dnů. Úspora 50-70%.',
    ctaPrimary: 'Spustit týden zdarma',
    ctaSecondary: 'Objednat BPO služby',
    trustBadge: 'První týden zdarma • Bez karty • Zrušení kdykoliv',
    microProof: [
      'Pokrytí 24/7/365',
      'Vícejazyčné týmy (EN/FR/ES/AR + 8 dalších)',
      'Úspora 50-70% oproti západní Evropě/USA',
      'Go-live za 7 dní',
      'Soulad s ISO 27001 • GDPR • PCI-DSS',
    ],
    proofMetrics: [
      { value: '200+', label: 'Klienti' },
      { value: '500+', label: 'Agenti' },
      { value: '12+', label: 'Jazyky' },
      { value: '95%+', label: 'CSAT' },
      { value: '99.9%', label: 'SLA Uptime' },
      { value: '50-70%', label: 'Úspora nákladů' },
      { value: '7 dní', label: 'Nasazení' },
    ],
    trustedBy: 'Důvěra více než 200 firem po celém světě',
    dialogTitle: 'Naplánovat úvodní hovor',
  },
  hu: {
    badge: 'Vállalati szintű BPO és Digitális Gyár',
    h1: 'A világ vezető BPO és Digitális Gyára — globális növekedés Marokkóból, Spanyolországból és Dubajból',
    sub: '500+ ügynök, 12+ nyelv, 200+ vállalati ügyfél. Indulás 7 napon belül. 50-70% költségmegtakarítás.',
    ctaPrimary: 'Kezdje az ingyenes hetet',
    ctaSecondary: 'BPO szolgáltatás rendelése',
    trustBadge: 'Első hét ingyenes • Nincs bankkártya • Bármikor lemondható',
    microProof: [
      '24/7/365 lefedettség',
      'Többnyelvű csapatok (EN/FR/ES/AR + 8 további)',
      '50-70% megtakarítás Nyugat-Európához/USA-hoz képest',
      'Go-live 7 nap alatt',
      'ISO 27001 • GDPR • PCI-DSS megfelelés',
    ],
    proofMetrics: [
      { value: '200+', label: 'Ügyfél' },
      { value: '500+', label: 'Ügynök' },
      { value: '12+', label: 'Nyelv' },
      { value: '95%+', label: 'CSAT' },
      { value: '99.9%', label: 'SLA rendelkezésre állás' },
      { value: '50-70%', label: 'Megtakarítás' },
      { value: '7 nap', label: 'Indítás' },
    ],
    trustedBy: 'Világszerte több mint 200 cég bízik bennünk',
    dialogTitle: 'Felfedező hívás foglalása',
  },
  fi: {
    badge: 'Enterprise-tason BPO ja digitaalinen tehdas',
    h1: 'Maailman johtava BPO ja digitaalinen tehdas — vauhditamme globaalia kasvua Marokosta, Espanjasta ja Dubaista',
    sub: '500+ agenttia, 12+ kieltä, 200+ enterprise-asiakasta. Käyttöönotto 7 päivässä. Säästä 50-70%.',
    ctaPrimary: 'Aloita ilmainen viikko',
    ctaSecondary: 'Tilaa BPO-palvelut',
    trustBadge: 'Ensimmäinen viikko ilmainen • Ei korttia • Peruuta milloin vain',
    microProof: [
      '24/7/365 kattavuus',
      'Monikieliset tiimit (EN/FR/ES/AR + 8 muuta)',
      '50-70% säästö verrattuna Länsi-Eurooppaan/USA:han',
      'Go-live 7 päivässä',
      'ISO 27001 • GDPR • PCI-DSS -linjassa',
    ],
    proofMetrics: [
      { value: '200+', label: 'Asiakkaat' },
      { value: '500+', label: 'Agentit' },
      { value: '12+', label: 'Kielet' },
      { value: '95%+', label: 'CSAT' },
      { value: '99.9%', label: 'SLA käyttöaste' },
      { value: '50-70%', label: 'Säästöt' },
      { value: '7 päivää', label: 'Käyttöönotto' },
    ],
    trustedBy: 'Yli 200 yritystä luottaa meihin maailmanlaajuisesti',
    dialogTitle: 'Varaa kartoituspuhelu',
  },
};

/**
 * Adds homepage hero translations for hi/ro/cs/hu/fi.
 * Called once at app startup.
 */
export function applyHomeContentTier2Patch() {
  const hero = homeContent.hero as Record<string, HeroContent>;

  for (const [lang, data] of Object.entries(heroPatch)) {
    hero[lang] = data;
  }
}
